"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fichiersColumns = void 0;
const globals_1 = require("./globals");
const lists_1 = require("./lists");
exports.fichiersColumns = [
    {
        id: "unid", header: (0, globals_1._)("N°"), width: 80,
        css: { "text-align": "right" }, sort: "int", hidden: false
    },
    {
        id: "idTypeDocument", header: (0, globals_1._)("Type doc."), width: "100",
        options: lists_1.typeDocumentList, sort: "text"
    },
    {
        id: "description", header: (0, globals_1._)("Description"), width: "300",
        sort: "text"
    }, {
        id: "fileDate", header: (0, globals_1._)("Créé le"), width: "140",
        sort: "raw", format: webix.i18n.dateFormatStr
    },
    {
        id: "utilisateur", header: (0, globals_1._)("Utilisateur"), width: "180",
        sort: "text"
    },
    {
        id: "tiers", header: (0, globals_1._)("Tiers"), width: "280",
        sort: "text"
    }
];
